var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"draggable-list list-group"},[_c('v-draggable',{attrs:{"handle":_vm.handle,"value":_vm.value},on:{"input":_vm.input}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }